import {Injectable} from "@angular/core";
import {Http, Headers, Response} from "@angular/http";
import {Observable} from "rxjs/Rx";
import "rxjs/operator/map";


export const CALLING_USER_ID = "5a3a75e2220000f904229210";

export const LOGIN_BASE = "/api/login/v2.0";
export const USERS_BASE = "/api/lemmings2/v1.0";
// export const USERS_BASE = 'http://localhost:8001/api/v1/proxy/namespaces/default/services/lemmings2/api/v1.0';
export const LOGIN_API_URL = `${LOGIN_BASE}/login`;
export const RESET_PASSWORD_API_URL = `${USERS_BASE}/password-recovery/change-password`;
export const RENEW_PASSWORD_API_URL = `${USERS_BASE}/password-recovery/renew-password`;
export const VALIDATE_TOKEN_API_URL = `${USERS_BASE}/password-recovery/validate-token`;
export const SET_PASSWORD_WITH_TOKEN_API_URL = `${USERS_BASE}/password-recovery/set-password`;
export const GET_USER_DETAILS = `/ng-api/lemmings2/v1.0/user/whoami`;

//used when password expired or when user want to change is known password
export interface ResetPasswordRequestBody {
  user: string;
  oldPass: string;
  newPass: string;
}

//used with token when user forgets its password
interface SetPasswordWithTokenRequestBody {
  token: string;
  newPass: string;
}


export interface User {

  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  active: boolean;
  accountId: string;
  label: string;
  previousLogin?: string;
  skills: [
    {
      type: string;
      values: string[];
    }
    ];
  extra: {
    superGroupsIds: string[];
    modules: string[];
    roles: string[];
  };
}

@Injectable()
export class APIService {
  constructor(private http: Http) {
  }

  public login(email: string, password: string): Observable<any> {
    //decode "email:password" to base64
    let encodedCredentials = btoa(`${email}:${password}`);

    //post a login request
    let headers = new Headers({
      Authorization: `Basic ${encodedCredentials}`,
    });
    headers.append('Content-Type', 'application/json');
    return this.http.post("/api/login/v2.0/login", null, {headers: headers});
  }

  //used when password expired or when user want to change is known password
  public resetPassword(
    oldPassword: string,
    newPassword: string,
    email: string
  ): Observable<Response> {
    let body: ResetPasswordRequestBody = {
      user: email,
      oldPass: oldPassword,
      newPass: newPassword
    };
    return this.http.put(RESET_PASSWORD_API_URL, body);
  }

  //sends user link for new password screen to its mail
  public renewPassword(mail: string): Observable<Response> {
    return this.http.post(RENEW_PASSWORD_API_URL, {email: mail});
  }

  public validateToken(token: string): Observable<Response> {
    return this.http.post(VALIDATE_TOKEN_API_URL, {token: token});
  }

  //used with token when user forgets its password
  public setPasswordWithToken(
    body: SetPasswordWithTokenRequestBody
  ): Observable<Response> {
    return this.http.post(SET_PASSWORD_WITH_TOKEN_API_URL, body);
  }

  //Get user details - last login time
  getUserDetails(): Observable<User> {
    return this.http.get(GET_USER_DETAILS)
      .map((res) => res.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/services/login/api.ts